export const FOOTER_CSS = `
  .ft {
    background: var(--color-midnight);
    color: var(--color-ivory);
    font-family: var(--font-sans);
    position: relative;
    overflow: hidden;
  }

  .ft::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg,
      transparent 0%,
      rgba(201,165,106,0.6) 30%,
      rgba(201,165,106,0.6) 70%,
      transparent 100%
    );
  }

  .ft::after {
    content: '';
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse 60% 40% at 80% 20%, rgba(31,111,95,0.06) 0%, transparent 60%),
      radial-gradient(ellipse 50% 50% at 10% 80%, rgba(201,165,106,0.04) 0%, transparent 60%);
    pointer-events: none;
  }

  .ft__inner {
    position: relative;
    z-index: 1;
    max-width: 1200px;
    margin: 0 auto;
    padding: 72px 2vw 0;
  }

  /* ── Row 1: 4 columns ── */
  .ft__top {
    display: grid;
    grid-template-columns: 3fr 1.5fr 1.5fr 3fr;
    gap: 40px;
    padding-bottom: 40px;
    border-bottom: 1px solid rgba(201,165,106,0.1);
  }

  /* ── Brand col ── */
  .ft__logo {
    display: inline-block;
    margin-bottom: 20px;
  }

  .ft__logo-svg text {
    font-family: var(--font-serif);
  }
  .ft__logo-img {
    height: 64px;
    width: auto;
    display: block;
    object-fit: contain;
  }

  .ft__tagline {
    font-size: 13px;
    font-weight: 300;
    line-height: 1.75;
    color: rgba(245,242,236,0.45);
    margin: 0;
  }

  /* ── Nav columns ── */
  .ft__col-label,
  .ft__office-label {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--color-gold);
    margin-bottom: 18px;
    display: block;
  }

  .ft__col-links {
    list-style: none;
    padding: 0; margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .ft__col-links a {
    font-size: 13px;
    font-weight: 300;
    color: rgba(245,242,236,0.5);
    text-decoration: none;
    letter-spacing: 0.01em;
    transition: color 0.2s;
  }

  .ft__col-links a:hover {
    color: var(--color-ivory);
  }

  /* ── Social icons ── */
  .ft__social {
    display: flex;
    gap: 10px;
    margin-bottom: 4px;
  }

  .ft__social-link {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid rgba(201,165,106,0.2);
    color: rgba(245,242,236,0.45);
    text-decoration: none;
    transition: border-color 0.22s, color 0.22s, background 0.22s;
  }

  .ft__social-link:hover {
    border-color: var(--color-gold);
    color: var(--color-gold);
    background: rgba(201,165,106,0.06);
  }

  /* ── Subscribe form ── */
  .ft__subscribe {
    display: flex;
    flex-direction: row;
    gap: 0;
  }

  .ft__subscribe-input {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(201,165,106,0.2);
    color: var(--color-ivory);
    font-family: var(--font-sans);
    font-size: 12px;
    font-weight: 300;
    padding: 9px 12px;
    outline: none;
    transition: border-color 0.2s;
    width: 100%;
    box-sizing: border-box;
  }

  .ft__subscribe-input::placeholder {
    color: rgba(245,242,236,0.3);
  }

  .ft__subscribe-input:focus {
    border-color: rgba(201,165,106,0.5);
  }

  .ft__subscribe-btn {
    background: none;
    border: 1px solid rgba(201,165,106,0.4);
    color: rgba(245,242,236,0.7);
    font-family: var(--font-sans);
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    padding: 9px 16px;
    cursor: pointer;
    transition: background 0.22s, border-color 0.22s, color 0.22s;
    flex-shrink: 0;
    white-space: nowrap;
  }

  .ft__subscribe-btn:hover {
    background: rgba(201,165,106,0.1);
    border-color: var(--color-gold);
    color: var(--color-ivory);
  }

  .ft__subscribe-thanks {
    font-size: 12px;
    font-weight: 300;
    color: rgba(201,165,106,0.8);
    margin: 0;
    letter-spacing: 0.03em;
  }

  /* ── Row 2: Office columns ── */
  .ft__offices {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    padding: 40px 0 48px;
    border-bottom: 1px solid rgba(201,165,106,0.1);
  }

  .ft__office-list {
    list-style: none;
    padding: 0; margin: 0;
    display: flex;
    flex-direction: column;
    gap: 9px;
  }

  .ft__office-list li {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    font-size: 13px;
    font-weight: 300;
    color: rgba(245,242,236,0.45);
    line-height: 1.55;
  }

  .ft__office-list li svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: rgba(201,165,106,0.5);
  }

  .ft__office-list a {
    color: inherit;
    text-decoration: none;
    transition: color 0.2s;
  }

  .ft__office-list a:hover {
    color: rgba(245,242,236,0.8);
  }

  /* ── Bottom bar ── */
  .ft__bottom {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 24px 2vw 32px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .ft__copy {
    font-size: 11px;
    font-weight: 300;
    letter-spacing: 0.04em;
    color: rgba(245,242,236,0.25);
  }

  .ft__bottom-links {
    display: flex;
    gap: 20px;
  }

  .ft__bottom-links a {
    font-size: 11px;
    font-weight: 300;
    letter-spacing: 0.04em;
    color: rgba(245,242,236,0.25);
    text-decoration: none;
    transition: color 0.2s;
  }

  .ft__bottom-links a:hover {
    color: rgba(245,242,236,0.6);
  }

  /* ── Responsive ── */
  @media (max-width: 960px) {
    .ft__top {
      grid-template-columns: 1fr 1fr;
      gap: 36px 32px;
    }
    .ft__brand {
      grid-column: 1 / -1;
    }
    .ft__offices {
      grid-template-columns: 1fr 1fr;
      gap: 32px;
    }
  }

  @media (max-width: 560px) {
    .ft__top {
      grid-template-columns: 1fr 1fr;
      gap: 32px 20px;
    }
    .ft__brand {
      grid-column: 1 / -1;
    }
    .ft__offices {
      grid-template-columns: 1fr;
      gap: 28px;
    }
    .ft__bottom {
      flex-direction: column;
      text-align: center;
      gap: 8px;
    }
  }
`
